module.exports = __webpack_public_path__ + "img/designer1.720807d5.png";